module.exports = __webpack_public_path__ + "static/media/img_-dianshang_1@2x.532ce427.png";